import { store, getContext } from '@wordpress/interactivity';

const isValidLink = ( event ) => {
  return 0 === event.button && // Left clicks only.
	! event.metaKey && // Open in new tab (Mac).
	! event.ctrlKey && // Open in new tab (Windows).
	! event.altKey && // Download.
	! event.shiftKey &&
	! event.defaultPrevented;
};

const { state, actions, callbacks } = store( 'gcore/query', {
	state: {
		get postType() {
			return getContext()?.query?.postType;
		},
  },
	actions: {
    handleClick: () => {
      console.log( 'handleClick' );
    },
  },
	callbacks: {
    init: () => {
			console.log( state.postType );
    },
  },
} );
